import React from "react";
import styles from "./LoadingStory.module.css";

const LoadingStory = (props) => {
  return (
    <div className={[styles.loadingStory, "section", "dark"].join(" ")}>
      <div className={styles.logoContainer}>
        <div className={styles.logo}>
          <img src="./img/es_common_loading.gif" alt="Electric Shuffle" />
          <div>Loading...</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingStory;
